import FieldPresenceValidator from "../navigableValidators/fieldPresenceValidator";
import NavigableValidation from "./navigableValidation";
import FormDetailAgency from "../../../formability/form_builder/models/formDetails/formDetailAgency";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";

export default class FormDetailAgencyValidation extends NavigableValidation<FormDetailAgency> {
  validators = this.publicProfileFields.map(i => new FieldPresenceValidator({
    validatorKey: i,
    section: ValidationModalSection.PublicProfile
  }));

  get publicProfileFields(): Array<string> {
    return [
      'name',
      'contact_name',
      'contact_email',
      'street',
      'city',
      'state',
      'zip'
    ]
  }

  getAnchorHash(propName: string, value?): string {
    return propName.replace(/ /g, '');
  }
}